// extracted by mini-css-extract-plugin
module.exports = {"smallhr":"TopNote_smallhr__1VJoR"};